import { useEffect, useState } from "react";

import Slider from "react-slick";

import "./style.css";

function CustomSliderV2({
    children,
    sliderRef = null,
    page = 0,
    rows = 1,
    infinite = false,
    speed = 500,
    slidesToShow = 1,
    swipeToSlide = true,
    swipe = true,
    arrows = false,
    draggable = true,
    adaptiveHeight = true,
    afterChange = () => { },
    initialSlide = null,
    ...rest
}) {
    const [currentPage, setCurrentPage] = useState(page);

    useEffect(() => {
        setCurrentPage(page);
    }, [page]);

    const settings = {
        rows: rows,
        infinite: infinite,
        speed: speed,
        slidesToShow: slidesToShow,
        swipeToSlide: swipeToSlide,
        swipe: swipe,
        arrows: arrows,
        draggable: draggable,
        adaptiveHeight: adaptiveHeight,
        afterChange: afterChange,

        initialSlide: initialSlide || currentPage,
    };

    return (
        <div className="custom-slider-v2" {...rest}>
            <Slider ref={sliderRef} {...settings}>
                {children}
            </Slider>
        </div>
    );
}

export default CustomSliderV2;